import { createSlice } from '@reduxjs/toolkit'

type accountState = {
  account: string
  password: string
}

const initialState: accountState = {
  account: '',
  password: '',
}

const accountReducer = createSlice({
  name: 'account',
  initialState: initialState,
  reducers: {
    accountState(state, action) {
      state.account = action.payload
    },
    passwordState(state, action) {
      state.password = action.payload
    },
  },
})

export const { accountState, passwordState } = accountReducer.actions

export default accountReducer.reducer
